import {
  GET_SERVICE_RECOVERY,
  GET_SERVICE_RECOVERY_SUCCESS,
  GET_SERVICE_RECOVERY_FAILURE,
} from '../actions/serviceRecovery';

/**
 * @type {import('../types/state/serviceRecoveryState').ServiceRecoveryState}
 */
const INITIAL_STATE = { loading: true, cached: false };

export default function serviceRecoveryReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_SERVICE_RECOVERY:
      return {
        ...state,
        loading: true,
        cached: true,
      };
    case GET_SERVICE_RECOVERY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload,
      };
    case GET_SERVICE_RECOVERY_FAILURE:
      return {
        ...state,
        loading: false,
        cached: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
